import L from "leaflet";

export const MAP_TILES_URL =
  "https://core-renderer-tiles.maps.yandex.net/tiles?l=map&v=23.08.27-0-b230722061630&x={x}&y={y}&z={z}&lang=ru_RU";

export const CRS_YANDEX = L.CRS.EPSG3395;
